import { baseApi } from './baseApi';

export type Permission = {
  value: boolean | 'true' | 'false';
  permission: string;
};

export type PermissionResponse = {
  id: number;
  workspace_id: number | null;
  role: string;
  permissions: Permission[];
  created_at: string;
  updated_at: string;
};

export interface GlobalPermissionsResponse {
  global: boolean;
  permissions: PermissionResponse;
}

export interface WorkspacePermissionsResponse {
  workspace_id: number;
  permissions: PermissionResponse;
}

export interface SitePermissionsResponse {
  site_id: number;
  workspace_id: number;
  permissions: PermissionResponse;
}

export const permissions = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPermissions: build.query<GlobalPermissionsResponse, { role: string }>({
      query: ({ role }) => `/permission/global?role=${role}`,
    }),
    getWorkspacePermissions: build.query<
      WorkspacePermissionsResponse,
      { workspace_id: string }
    >({
      query: ({ workspace_id }) =>
        `/permission/workspace?workspace=${workspace_id}`,
    }),
    getSitePermissions: build.query<
      SitePermissionsResponse,
      { site_id: string }
    >({
      query: ({ site_id }) => `/permission/site?site=${site_id}`,
    }),
  }),
});

export const { useGetPermissionsQuery, useGetWorkspacePermissionsQuery } =
  permissions;
